import accounting from "accounting";
import g from "./globals";
import dom from "./dom";
import { features } from "./features";

const multiplier = 100;

export const getRatio = (ratio = { document: 1 }) => {
  if (g.deviceOrientation === "portrait" && g.isTablet) {
    return (ratio.ipadv || ratio.document) * multiplier;
  } else if (g.deviceOrientation === "landscape" && g.isTablet) {
    return (ratio.ipadh || ratio.document) * multiplier;
  } else if (g.channels.desktop || g.channels.standalone) {
    return (ratio.desktop || ratio.document) * multiplier;
  } else if (g.channels.mobile || g.channels.apps || g.channels.minip) {
    return (ratio.mobile || ratio.ipadv || ratio.ipadh || ratio.document) * multiplier;
  }
};
export const formatPrice = (price, fix) => {
  /*
Formatea el precio procedente del APIRest
@param price
@param rest Nodo locale con la configuración de formateo

Ejemplos:

     * KR_ko
     formatPrice(123456) -> "123,456 원"
     * ES_es
     formatPrice(123456) -> "1.234,56 EUR"

*/
  if (fix == null) {
    fix = false;
  }
  if (!price) return "";
  if (fix) {
    price *= Math.pow(10, Math.abs(g.currencyDecimals));
  }

  price = price / Math.pow(10.0, Math.abs(g.currencyDecimals));
  const withCode = /¤¤/.test(g.currencyFormat);
  const options = {
    symbol: withCode ? g.currencyCode : g.currencySymbol,
    format: g.currencyFormat.replace(/¤+/, "%s").replace(/#[^\s]+/, "%v"),
    precision: /\.(0+)/.test(g.currencyFormat) ? RegExp.$1.length : 0,
    decimal: g.decimalsSeparator,
    thousand: g.thousandsSeparator,
  };

  return accounting.formatMoney(price, options);
};

// TODO: legacy
export const desiredWidth = options => {
  const defaults = {
    width: g.channels.mobile ? screen.width : Math.max(screen.width, screen.height),
    zoom: 1,
  };
  options = Object.assign({}, defaults, options);

  let { width } = options;
  const devicePixelRatio = Math.min(Math.ceil(options.devicePixelRatio || window.devicePixelRatio), 2);
  width *= devicePixelRatio;
  if (!g.webMobile) {
    width *= options.zoom;
  }

  return Math.min(width, 2560);
};

// TODO: legacy
export const srcForResolution = path => {
  // take care this is because from enhancements it comes as .st.
  // however from toprops ot it comes without
  // TODO: I think images from enhancements should not come width .st. by default
  if (path.indexOf(".st.") < 0) {
    path = path.replace(/\.(jpg|png)/, `.st.$1`);
  }
  path = path.replace(/\.st\./, () => {
    const replacement = () => {
      if (screen.width < 1024 || g.channels.minip) {
        return "lo";
      } else if (screen.width <= 1920 || features.touch) {
        return "st";
      }
      return "hi";
    };
    return `.${replacement()}.`;
  });

  if (!/ts=/.test(path)) {
    const stringArray = Array.from(path.split("?"));
    if (stringArray[1]) {
      path += `&ts=${g.lastStaticSyncTimestamp}`;
    } else {
      path += `?ts=${g.lastStaticSyncTimestamp}`;
    }
  }

  return path;
};

export const isHome = () => {
  const html = document.querySelector("html");
  return /(I|V|W|S)\d{4}R?-HOME/.test(html.id);
};

export const isHomeMobile = () => g.channels.mobile && isHome();

export const getChannel = () => {
  if (g.isTablet) {
    return "ipad";
  }
  if (g.channels.mobile) {
    return "mobile";
  }
  return "desktop";
};

export const bgColor = props => {
  if (!props.customProps) return;
  // bgColor
  const bgColor = props.customProps.bgColor || null;
  if (bgColor) {
    let color = props.customProps.bgColor;
    // LEGACY
    const channel = getChannel();
    if (bgColor instanceof Object) color = bgColor[channel];
    if (color) dom.addBodyClass(`bg-${color.replace("#", "")}`);
  }
};

export const toCamelCase = (str = "") => {
  const text = str.toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const defaultSection = () => {
  let preferred = g.regularSections[0];
  const fromQueryString = window.location.search.match("sectionName=(.*)");
  if (fromQueryString) {
    const desiredSection = window.location.search.match("sectionName=(.*)")[1];
    const matchedSection = g.regularSections.findIndex(
      section => desiredSection.toLocaleLowerCase().indexOf(section.toLocaleLowerCase()) > -1
    );
    if (matchedSection > -1) {
      preferred = g.regularSections[matchedSection];
    }
  } else if (window.sectionPersistence && window.sectionPersistence.getPreferredSection()) {
    const lastVisitedSection = window.sectionPersistence.getPreferredSection();
    if (g.regularSections.includes(lastVisitedSection)) {
      preferred = lastVisitedSection;
    }
  }
  return preferred;
};

export const filterElement = (elm, contentForMobile) => {
  const language = elm.filters?.l10n?.length > 0 ? elm.filters.l10n : false;
  let filteredElement = false;
  if (language) {
    if (language.includes(g.countryCode) && (language.includes(g.langCode) || !language.includes(`!${g.langCode}`))) {
      filteredElement = elm;
    } else if (!language.includes(`!${g.countryCode}`)) {
      if (language.includes(g.langCode)) {
        filteredElement = elm;
      } else if (!language.includes(`!${g.langCode}`)) {
        language.map(lang => {
          if (/^(!)([a-z]{2}|[A-Z]{2})$/.test(lang)) {
            filteredElement = elm;
          }
          return filteredElement;
        });
      }
    }
  } else {
    filteredElement = elm;
  }
  const devices = elm.filters?.devices;
  if (filteredElement && devices?.length > 0) {
    filteredElement = false;
    let channel = "desktop";
    if (features.touch) {
      channel = contentForMobile ? "mobile" : "ipadv";
    }
    if (features.tablet) channel = "ipad";
    if (devices.indexOf(channel) > -1) {
      filteredElement = elm;
    }
    // IPAD could have orientation too
    if (devices.indexOf("ipadh") > -1 || devices.indexOf("ipadv") > -1) {
      if (g.isTablet) {
        filteredElement = elm;
      }
    }
  }
  return filteredElement;
};

export const getSuitableDisplay = (frames = {}) => {
  const selectedDisplay = frames.reduce((currentFrame, frame) => {
    if (currentFrame === null) {
      currentFrame = frame;
    } else if (
      (frame.metadata.width >= window.innerWidth && currentFrame.metadata.width >= window.innerWidth) ||
      (frame.metadata.width <= window.innerWidth && currentFrame.metadata.width <= window.innerWidth)
    ) {
      currentFrame =
        Math.abs(currentFrame.metadata.width - window.innerWidth) < Math.abs(frame.metadata.width - window.innerWidth)
          ? currentFrame
          : frame;
    } else if (frame.metadata.width <= window.innerWidth) {
      currentFrame = frame;
    }
    return currentFrame;
  }, null);
  return selectedDisplay;
};

const needMeasure = prop => {
  return !isNaN(prop) && !/%|vw|vh|em|rem|px|pt/.test(prop);
};

export const resolveStyles = styles => {
  const { width, height, marginTop, marginLeft, paddingTop, fontSizeRatio } = styles;
  const formattedStyles = {
    ...styles,
  };
  if (width && needMeasure(width)) formattedStyles.width = `${width}%`;
  if (height && needMeasure(height)) formattedStyles.height = `${height}%`;
  if (marginTop && needMeasure(marginTop)) formattedStyles.marginTop = `${marginTop}%`;
  if (marginLeft && needMeasure(marginLeft)) formattedStyles.marginLeft = `${marginLeft}%`;
  if (paddingTop && needMeasure(paddingTop)) formattedStyles.paddingTop = `${paddingTop}%`;
  if (fontSizeRatio && needMeasure(fontSizeRatio)) {
    formattedStyles.fontSize = `${fontSizeRatio}vw`;
  }
  return formattedStyles;
};

export const filterElements = (elements, getFormattedLayer) => {
  return elements.reduce((filteredElms, elm) => {
    const filteredElm = getFormattedLayer(filterElement(elm), true);
    if (filteredElm) {
      if (filteredElm.children) {
        filteredElm.children = filterElements(filteredElm.children, getFormattedLayer);
      }
      filteredElms.push(filteredElm);
    }
    return filteredElms;
  }, []);
};
